module.exports = __webpack_public_path__ + "static/img/02_06_modulation.105bd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_06_modulation.png
// module id = B1qJ
// module chunks = 12